import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download--sprite",
  "use": "download--sprite-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol viewBox=\"0 0 14 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download--sprite\">\n<path d=\"M14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5ZM6 8.5V2.5H8V8.5H9.17L7 10.67L4.83 8.5H6ZM0 15.5H14V17.5H0V15.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol